export default __webpack_public_path__ + "static/media/duke-colab.87389285.png";